import { ErrorLayout } from 'components';
import { useRouteError } from 'helpers';

export const ErrorFallback = () => {
  const { message } = useRouteError();

  return <ErrorLayout subtitle={message} />;
};
